export enum BatchTemplateLabelType {
    'text' = 'text',
    'image' = 'image',
}
